<script setup lang="ts">
defineOptions({
  name: 'LayoutAuthorization',
});

useThemeStore();

const { version } = useAppConfig();
const { isMobileShell } = useMobileShell();
</script>

<template>
  <v-app>
    <template v-if="isMobileShell">
      <div :class="$style.mobileShell">
        <header :class="$style.mobileTop">
          <v-spacer />

          <DashboardBaseDarkModeToggel class="mr-1" />

          <DashboardBaseLanguageSelect />
        </header>

        <main :class="$style.mobileMain">
          <slot />
        </main>

        <footer :class="$style.mobileVersion">
          App version: {{ version }}
        </footer>
      </div>
    </template>

    <template v-else>
      <div class="d-flex ma-4 align-center">
        <v-spacer />

        <dashboard-base-dark-mode-toggel class="mr-4" />

        <dashboard-base-language-select />
      </div>

      <div :class="$style.auth">
        <v-card :class="$style['auth-container']">
          <slot />
        </v-card>
      </div>

      <div :class="$style.version">
        App version: {{ version }}
      </div>
    </template>
  </v-app>
</template>

<style lang="scss" module>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  .auth-container {
    width: 100%;
    max-width: 400px;
    padding: 20px;
    border-radius: 10px;

    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
  }
}

.version {
  pointer-events: none;
  user-select: none;

  position: fixed;
  right: 16px;
  bottom: 12px;

  font-size: 14px;

  opacity: .35;
}

.mobileShell {
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 100%;
  min-height: 100dvh;

  background: radial-gradient(120% 80% at 50% -10%, rgba(var(--v-theme-primary), .16), transparent 55%),
    rgb(var(--v-theme-background));
}

.mobileTop {
  display: flex;
  flex-shrink: 0;
  align-items: center;

  padding: .75rem 1rem;
  padding-top: calc(.75rem + env(safe-area-inset-top, 0px));
}

.mobileMain {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  padding: 1rem 1.25rem 1.5rem;
}

.mobileVersion {
  flex-shrink: 0;

  padding: .75rem 1rem calc(.75rem + env(safe-area-inset-bottom, 0px));

  font-size: 12px;
  text-align: center;

  opacity: .4;
}
</style>
